export const actionTypes = {
    SET_FOOD_ITEMS: 'SET_FOOD_ITEMS',
    SET_CATEGORIES: 'SET_CATEGORIES',
    TOGGLE_CART: 'TOGGLE_CART',
    SET_CART_ITEMS: 'SET_CART_ITEMS',
    SET_CART_TOTAL: 'SET_CART_TOTAL',
    SET_USER_CART_INFO: 'SET_USER_CART_INFO',
    SET_COOKIE_ACCEPT: 'SET_COOKIE_ACCEPT',
    SET_PAYMENT: 'SET_PAYMENT',
    SET_VERIFICATION_CODE: 'SET_VERIFICATION_CODE',
    SET_SCHEDULE: 'SET_SCHEDULE'
}

const reducer = (state, action) => {
    switch (action.type) {
        case actionTypes.SET_CATEGORIES:
            return {
                ...state,
                categories: action.categories,
            };
        case actionTypes.SET_FOOD_ITEMS:
            return {
                ...state,
                foodItems: action.foodItems,
            };
        case actionTypes.TOGGLE_CART:
            return {
                ...state,
                showCart: action.showCart,
            };
        case actionTypes.SET_CART_ITEMS:
            return {
                ...state,
                cartItems: action.cartItems,
            };
        case actionTypes.SET_CART_TOTAL:
            return {
                ...state,
                cartTotal: action.cartTotal,
            };
        case actionTypes.SET_USER_CART_INFO:
            return {
                ...state,
                userCartInfo: action.userCartInfo
            };
        case actionTypes.SET_COOKIE_ACCEPT:
            return {
                ...state,
                cookieAccept: action.cookieAccept
            };
        case actionTypes.SET_PAYMENT:
            return {
                ...state,
                payment: action.payment
            };
        case actionTypes.SET_VERIFICATION_CODE:
            return {
                ...state,
                verificationCode: action.verificationCode
            };
        case actionTypes.SET_SCHEDULE:
            return {
                ...state,
                schedule: action.schedule
            };
        default:
            return state;
    }
}

export default reducer;